<template>
    <eg-modal :show="show" height="auto" @close="$emit('close', false)">
        <p class="center" slot="header">Convidar</p>
        <div slot="body">
            <div>
                <p>
                    Insira abaixo as informações do fornecedor que você gostaria que participasse da cotação.
                </p>
                <div class="input-field">
                    <eg-input
                        :valid="valid"
                        :value="tradingName"
                        v-model="tradingName"
                        placeholder-text="Nome fantasia"
                        background-color="#FFF"
                        :rules="tradingRules"
                        @valid="tradingRules.valid = $event"
                    />
                </div>
                <div class="input-field">
                    <eg-input
                        :valid="valid"
                        :value="email"
                        v-model="email"
                        placeholder-text="Email"
                        background-color="#FFF"
                        :rules="emailRules"
                        @valid="emailRules.valid = $event"
                    />
                </div>
                <div class="input-field">
                    <eg-input
                        :valid="valid"
                        :value="phone"
                        v-model="phone"
                        :mask="['(##) ####-####', '(##) #####-####']"
                        placeholder-text="Telefone"
                        background-color="#FFF"
                    />
                </div>
            </div>
        </div>
        <eg-button slot="footer" :disabled="!formValid" @click="validateForm">Adicionar</eg-button>
    </eg-modal>
</template>

<script>
import moment from 'moment';
import { inviteAdditionalSuppliers } from '@/services';
import { mapActions } from 'vuex';
export default {
    name: 'InviteSuppliers',
    props: {
        show: Boolean,
        competitionData_id: Number
    },
    data: () => ({
        valid: true,
        tradingName: '',
        loading: false,
        email: '',
        phone: '',
        tradingRules: {
            name: 'Nome fantasia',
            type: 'text',
            required: true,
            valid: true
        },
        emailRules: {
            name: 'Email',
            type: 'email',
            required: false,
            valid: true
        }
    }),
    methods: {
        ...mapActions('notification', ['showNotification']),
        async validateForm() {
            try {
                this.loading = true;
                this.valid = !this.valid;
                if (this.formValid && this.tradingName.trim() != '') {
                    const supplier = {
                        name: this.tradingName,
                        email: this.email,
                        phone: this.phone,
                        status: 'not visualized',
                        token: '',
                        disabled: false,
                        invited_at: moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD')
                    };
                    const invitedSuppliers = {
                        suppliers: [supplier]
                    };
                    const data = {
                        id: this.competitionData_id,
                        recipients: invitedSuppliers
                    };
                    await inviteAdditionalSuppliers(data);
                    this.showNotification({ text: 'Fornecedor convidado com sucesso!', type: 'success' });
                    this.$emit('close', false);
                }
            } catch (e) {
                console.error(e);
                this.showNotification({ text: e.status, type: 'error' });
            } finally {
                this.loading = false;
            }
        }
    },
    computed: {
        btnColor() {
            return this.formValid ? 'blue' : 'gray';
        },
        formValid() {
            return this.tradingRules.valid ? true : false;
        }
    }
};
</script>

<style></style>
